module.exports = __webpack_public_path__ + "img/icon_service2.5794c6ff.png";